// TermsOfService.js
import React, { useState, useEffect, useRef } from 'react';
import './Pages/PagesCss/TermsOfService.css';
import { useNavigate } from 'react-router-dom';

// ─── Icons ────────────────────────────────────────────────────────────────────
const Ic = {
  File:      (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M14 2V8H20M16 13H8M16 17H8M10 9H8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Users:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="9" cy="7" r="3" stroke="currentColor" strokeWidth="1.8"/><path d="M3 20C3 17.24 5.69 15 9 15C12.31 15 15 17.24 15 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M16 11C17.66 11 19 9.66 19 8C19 6.34 17.66 5 16 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M21 20C21 17.79 19.21 16 17 16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Shield:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 3L4 7V12C4 16.42 7.58 21 12 21C16.42 21 20 16.42 20 12V7L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Dollar:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 7V17M9.5 9.5C9.5 8.4 10.62 8 12 8C13.38 8 14.5 8.67 14.5 9.75C14.5 10.83 13.5 11.25 12 11.5C10.5 11.75 9.5 12.28 9.5 13.5C9.5 14.6 10.62 15.5 12 15.5C13.38 15.5 14.5 15.1 14.5 14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Ban:       (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M5.64 5.64L18.36 18.36" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Copyright: (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M14.5 9.5C13.5 8.5 12.5 8 11.5 8C9.5 8 8 9.79 8 12C8 14.21 9.5 16 11.5 16C12.5 16 13.5 15.5 14.5 14.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Scale:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 3V21M12 3L6 8M12 3L18 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 13L6 8L9 13C9 14.66 7.66 16 6 16C4.34 16 3 14.66 3 13Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M15 13L18 8L21 13C21 14.66 19.66 16 18 16C16.34 16 15 14.66 15 13Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M4 21H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Trash:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M3 6H21M8 6V4H16V6M19 6L18 20H6L5 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Update:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 12C4 7.58 7.58 4 12 4C14.67 4 17.04 5.27 18.54 7.25" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M20 12C20 16.42 16.42 20 12 20C9.33 20 6.96 18.73 5.46 16.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M16 7L18.54 7.25L20 5M8 17L5.46 16.75L4 19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Mail:      (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.8"/><path d="M2 8L12 14L22 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Lock:      (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.8"/><path d="M8 11V8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8V11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><circle cx="12" cy="16" r="1.5" fill="currentColor"/></svg>,
  Globe:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 3C12 3 8 7 8 12C8 17 12 21 12 21M12 3C12 3 16 7 16 12C16 17 12 21 12 21M3 12H21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  ChevronRight: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M9 5L16 12L9 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  ArrowUp:   (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 19V5M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Check:     (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M5 12L10 17L19 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Info:      (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 8V8.01M12 11V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>,
  Zap:       (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M13 2L4.5 13.5H12L11 22L19.5 10.5H12L13 2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/></svg>,
};

// ─── Section data ─────────────────────────────────────────────────────────────
const SECTIONS = [
  {
    id: 'acceptance',
    icon: Ic.File,
    title: '1. Acceptance of Terms',
    color: '#3B82F6',
    content: [
      {
        subtitle: 'Agreement to these terms',
        body: `By accessing or using QuickPDFs.net ("the Service"), you agree to be bound by these Terms of Service ("Terms"), our Privacy Policy, and our Disclaimer, all of which are incorporated herein by reference.

These Terms constitute a legally binding agreement between you ("User", "you") and D-Tech Studios ("we", "us", "our"), the company that operates QuickPDFs.net.

If you are using the Service on behalf of an organisation, you represent and warrant that you have authority to bind that organisation to these Terms.`,
      },
      {
        subtitle: 'Minimum age requirement',
        body: `You must be at least 13 years of age to use QuickPDFs. If you are between 13 and 17, you may only use the Service with the consent and supervision of a parent or legal guardian who agrees to these Terms on your behalf.

Creating a paid account or subscription requires you to be at least 18 years of age, or to have explicit parental or guardian consent.`,
      },
      {
        subtitle: 'Changes to these Terms',
        body: `We reserve the right to modify these Terms at any time. When we make material changes, we will:

• Update the "Last updated" date at the top of this page
• Notify registered account holders by email at least 14 days before the changes take effect
• Display a prominent notice on the website

Your continued use of the Service after the effective date of any changes constitutes acceptance of the revised Terms. If you do not agree to the changes, you must stop using the Service and, if applicable, cancel your subscription before the changes take effect.`,
      },
    ],
  },
  {
    id: 'service',
    icon: Ic.Zap,
    title: '2. Description of Service',
    color: '#10B981',
    content: [
      {
        subtitle: 'What QuickPDFs provides',
        body: `QuickPDFs.net is a browser-based PDF processing platform that provides tools for merging, splitting, compressing, converting, editing, and securing PDF files and related document formats. The Service is operated by D-Tech Studios.

We offer three tiers of service:

Free Plan Access to all 22 PDF tools with limits of 2 files per day and 10 MB per file. No account required. No payment required. Free forever.

Pro Plan ($7.99/month or $5.99/month billed annually) Unlimited files, 100 MB per file, no watermarks, batch processing, priority processing queue, and 30-day file history. Requires account registration.

Business Plan ($19.99/month or $14.99/month billed annually) Everything in Pro, plus 500 MB per file, 90-day file history, API access, and 3 team seats. Requires account registration.`,
      },
      {
        subtitle: 'Service modifications',
        body: `D-Tech Studios reserves the right to modify, suspend, or discontinue the Service, or any part of it, at any time with or without notice. We will make reasonable efforts to provide advance notice to paid subscribers before making significant changes.

We shall not be liable to you or any third party for any modification, suspension, or discontinuation of the Service. Features advertised on the website represent current capabilities and may change over time as the product evolves.`,
      },
    ],
  },
  {
    id: 'accounts',
    icon: Ic.Users,
    title: '3. Accounts & Registration',
    color: '#8B5CF6',
    content: [
      {
        subtitle: 'Account creation',
        body: `To access Pro or Business plan features, you must create an account by providing a valid email address and creating a password. You may also sign in using a supported third-party authentication provider (e.g. Google).

You agree to provide accurate, current, and complete information during registration, and to update that information as necessary to keep it accurate. D-Tech Studios reserves the right to refuse registration or cancel accounts that provide false or misleading information.`,
      },
      {
        subtitle: 'Account security',
        body: `You are responsible for maintaining the confidentiality of your account credentials. You agree not to share your password with any third party, and to notify us immediately at support@quickpdfs.net if you suspect unauthorised access to your account.

D-Tech Studios will not be liable for any loss or damage arising from your failure to maintain account security. All actions taken through your account are your responsibility, whether or not authorised by you.`,
      },
      {
        subtitle: 'Team accounts (Business plan)',
        body: `Business plan subscribers may invite up to 3 team members ("Seats") to access the same account. The account holder is responsible for ensuring all team members comply with these Terms. Additional seats may be purchased at $4.99 per seat per month.

Removing a team member from your account terminates their access immediately. Any files processed by a removed team member that remain within the file history retention window will remain accessible to the account holder.`,
      },
      {
        subtitle: 'Account termination by user',
        body: `You may delete your account at any time from Account Settings → Profile → Delete Account. Upon deletion, all your personal data will be permanently removed within 30 days in accordance with our Privacy Policy.

If you have an active subscription, deleting your account will also cancel your subscription. You will retain access until the end of your current billing period but will not receive a prorated refund for unused time.`,
      },
    ],
  },
  {
    id: 'billing',
    icon: Ic.Dollar,
    title: '4. Billing & Payments',
    color: '#F59E0B',
    content: [
      {
        subtitle: 'Subscription billing',
        body: `Paid plans are billed on a recurring basis either monthly or annually, depending on the plan you select at sign-up. Your subscription renews automatically at the end of each billing period unless cancelled.

By subscribing, you authorise D-Tech Studios (via our payment processor, Stripe) to charge your payment method on a recurring basis. You represent that you are authorised to use the payment method you provide.`,
      },
      {
        subtitle: 'Pricing and price changes',
        body: `Current pricing is displayed on our Pricing page. We reserve the right to change subscription prices. If we increase the price of your current plan, we will provide at least 30 days' notice via email before the new price takes effect.

Price changes will apply at the start of your next billing cycle after the notice period. If you do not agree to the price change, you must cancel your subscription before the new price takes effect.`,
      },
      {
        subtitle: 'Free trial',
        body: `Pro plan includes a 7-day free trial. Business plan includes a 14-day free trial. No payment information is required to start a trial. At the end of the trial, you will be prompted to enter payment details to continue. If you do not enter payment details, your account will automatically revert to the Free plan you will not be charged.`,
      },
      {
        subtitle: 'Refund policy',
        body: `We offer a 7-day money-back guarantee on your first payment for any paid plan. If you are not satisfied, email support@quickpdfs.net within 7 days of your first charge and we will issue a full refund, no questions asked.

After the 7-day window, refunds are issued at our discretion, typically in cases of service outages lasting more than 24 hours that we caused, or billing errors on our part.

Annual subscriptions may be prorated and refunded within 30 days of purchase if you are genuinely unable to use the service due to a material limitation we failed to disclose.`,
      },
      {
        subtitle: 'Failed payments',
        body: `If a payment fails, we will retry the charge up to 3 times over 7 days. If payment continues to fail, your account will be downgraded to the Free plan. Your account data, including file history, will be preserved for 30 days. If you update your payment method and resubscribe within that window, your history and settings will be restored.`,
      },
    ],
  },
  {
    id: 'usage',
    icon: Ic.Shield,
    title: '5. Acceptable Use',
    color: '#10B981',
    content: [
      {
        subtitle: 'Permitted uses',
        body: `You may use QuickPDFs for any lawful personal, academic, or commercial purpose, subject to these Terms. This includes processing documents you own or have the right to process, converting files for legitimate business purposes, and using the API (Business plan) to integrate PDF processing into your own applications.`,
      },
      {
        subtitle: 'Prohibited uses',
        body: `You agree not to use the Service to:

• Upload, process, or distribute files that contain illegal content of any kind
• Infringe or circumvent third-party intellectual property rights, including bypassing DRM or copyright protections
• Upload malware, viruses, ransomware, or any other malicious files
• Attempt to reverse-engineer, decompile, or extract source code from the Service
• Scrape, crawl, or otherwise extract data from the Service using automated means (except via the API with a valid Business plan key)
• Attempt to gain unauthorised access to the Service, other accounts, or our infrastructure
• Use the Service to process files for the purpose of generating spam, phishing content, or fraudulent documents
• Resell or sublicense access to the Service without our written consent
• Circumvent usage limits (e.g. creating multiple free accounts to exceed the 2 files/day limit)
• Use the Service in a way that could damage, overload, or impair its availability to others`,
      },
      {
        subtitle: 'API usage (Business plan)',
        body: `Business plan subscribers who use the QuickPDFs API must comply with our API Terms, which are incorporated into these Terms by reference. API keys are non-transferable and must not be shared or embedded in publicly accessible client-side code.

Rate limits apply to API usage. Exceeding rate limits without prior agreement may result in temporary suspension of API access. If you require higher rate limits than those included in the Business plan, please contact us at api@quickpdfs.net.`,
      },
    ],
  },
  {
    id: 'content',
    icon: Ic.Copyright,
    title: '6. Intellectual Property',
    color: '#EF4444',
    content: [
      {
        subtitle: 'Your content',
        body: `You retain full ownership of any files, documents, or content you upload to QuickPDFs. By uploading files to the Service, you grant D-Tech Studios a limited, non-exclusive, temporary licence to process those files solely for the purpose of providing the requested service operation.

This licence terminates automatically when your files are deleted (within 1 hour of processing). We make no claim to ownership of your content and will not use it for any purpose other than performing the tool operation you requested.`,
      },
      {
        subtitle: 'Our intellectual property',
        body: `The QuickPDFs name, logo, website design, interface, source code, algorithms, and all other aspects of the Service (excluding your content) are the intellectual property of D-Tech Studios, protected by copyright, trademark, and other intellectual property laws.

You may not copy, reproduce, modify, create derivative works from, distribute, sell, or otherwise exploit any part of the Service without our express written permission. This includes but is not limited to: copying our interface design, cloning our tools for commercial use, or scraping our website content.`,
      },
      {
        subtitle: 'Feedback',
        body: `If you provide us with feedback, suggestions, or ideas about the Service ("Feedback"), you grant D-Tech Studios a perpetual, irrevocable, royalty-free licence to use that Feedback for any purpose, including incorporating it into the Service, without any obligation to compensate you or keep it confidential.`,
      },
    ],
  },
  {
    id: 'termination',
    icon: Ic.Ban,
    title: '7. Termination',
    color: '#EF4444',
    content: [
      {
        subtitle: 'Termination by D-Tech Studios',
        body: `We reserve the right to suspend or terminate your account and access to the Service, with or without notice, if we reasonably believe you have:

• Violated any provision of these Terms
• Provided false registration information
• Used the Service for illegal or fraudulent purposes
• Engaged in behaviour that harms other users or the integrity of the Service

If we terminate your account due to a breach of these Terms, you will not be entitled to any refund of prepaid subscription fees.`,
      },
      {
        subtitle: 'Effect of termination',
        body: `Upon termination of your account for any reason:

• Your access to the Service will cease immediately
• Any active subscription will be cancelled (effective immediately for breach, or at end of billing period for voluntary cancellation)
• Your personal data will be deleted within 30 days in accordance with our Privacy Policy
• You remain bound by all provisions of these Terms that are intended to survive termination, including Sections 6, 8, 9, and 10`,
      },
    ],
  },
  {
    id: 'liability',
    icon: Ic.Scale,
    title: '8. Limitation of Liability',
    color: '#8B5CF6',
    content: [
      {
        subtitle: 'Disclaimer of warranties',
        body: `THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND. TO THE FULLEST EXTENT PERMITTED BY LAW, D-TECH STUDIOS DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.

We do not warrant that: (a) the Service will meet your requirements; (b) the Service will be uninterrupted, timely, secure, or error-free; (c) any errors in the Service will be corrected; or (d) results obtained from the Service will be accurate or reliable.`,
      },
      {
        subtitle: 'Limitation of damages',
        body: `TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, D-TECH STUDIOS AND ITS AFFILIATES SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA, OR GOODWILL, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.

Our total aggregate liability to you for any claims arising from these Terms or your use of the Service shall not exceed the greater of: (i) the total amount you paid to D-Tech Studios in the 12 months preceding the claim, or (ii) USD $50.

Some jurisdictions do not permit the exclusion or limitation of certain damages. In such jurisdictions, our liability is limited to the fullest extent permitted by law.`,
      },
    ],
  },
  {
    id: 'indemnification',
    icon: Ic.Lock,
    title: '9. Indemnification',
    color: '#3B82F6',
    content: [
      {
        subtitle: 'Your obligation to indemnify',
        body: `You agree to indemnify, defend, and hold harmless D-Tech Studios, its directors, employees, agents, and affiliates from and against any and all claims, damages, losses, liabilities, costs, and expenses (including reasonable legal fees) arising from or related to:

• Your use of the Service in violation of these Terms
• Your violation of any applicable law or regulation
• Your violation of any third-party rights, including intellectual property rights
• The content of any files you upload or process through the Service
• Any misrepresentation you make in connection with the Service

We reserve the right to assume exclusive control of any matter subject to indemnification by you, in which case you agree to cooperate with our defence of such claim.`,
      },
    ],
  },
  {
    id: 'governing',
    icon: Ic.Globe,
    title: '10. Governing Law & Disputes',
    color: '#F59E0B',
    content: [
      {
        subtitle: 'Governing law',
        body: `These Terms shall be governed by and construed in accordance with the laws applicable to D-Tech Studios as a registered entity, without regard to conflict of law principles.

Users in the European Union benefit from the mandatory consumer protection laws of their country of residence, which may provide additional rights beyond those set out in these Terms.`,
      },
      {
        subtitle: 'Dispute resolution',
        body: `We want to resolve disputes quickly and informally. Before initiating any formal legal proceeding, you agree to first contact us at legal@quickpdfs.net describing your dispute, and give us 30 days to attempt an informal resolution.

If informal resolution fails, disputes shall be resolved by binding arbitration, except that either party may bring claims in small claims court if the claim qualifies. You waive the right to participate in a class action lawsuit or class-wide arbitration against D-Tech Studios.

Nothing in this Section prevents either party from seeking emergency injunctive or equitable relief for intellectual property infringement.`,
      },
      {
        subtitle: 'Severability',
        body: `If any provision of these Terms is found to be unenforceable or invalid by a court of competent jurisdiction, that provision will be modified to the minimum extent necessary to make it enforceable, and the remaining provisions of these Terms will continue in full force and effect.`,
      },
    ],
  },
  {
    id: 'general',
    icon: Ic.Info,
    title: '11. General Provisions',
    color: '#64748B',
    content: [
      {
        subtitle: 'Entire agreement',
        body: `These Terms, together with our Privacy Policy and Disclaimer, constitute the entire agreement between you and D-Tech Studios regarding the Service and supersede all prior agreements, representations, or understandings between the parties.`,
      },
      {
        subtitle: 'Waiver',
        body: `Our failure to enforce any provision of these Terms shall not constitute a waiver of that provision or of our right to enforce it in the future.`,
      },
      {
        subtitle: 'Assignment',
        body: `You may not assign or transfer your rights or obligations under these Terms without our prior written consent. D-Tech Studios may assign these Terms, in whole or in part, at any time without notice to you, including in connection with a merger, acquisition, or sale of assets.`,
      },
      {
        subtitle: 'No partnership',
        body: `Nothing in these Terms creates, or shall be construed to create, any partnership, joint venture, agency, franchise, or employment relationship between you and D-Tech Studios. You have no authority to bind D-Tech Studios in any way.`,
      },
    ],
  },
  {
    id: 'contact',
    icon: Ic.Mail,
    title: '12. Contact Us',
    color: '#10B981',
    content: [
      {
        subtitle: 'How to reach us',
        body: `If you have questions, concerns, or legal notices regarding these Terms of Service, please contact us:

General queries & support: support@quickpdfs.net
Legal & Terms matters: legal@quickpdfs.net
Privacy matters: privacy@quickpdfs.net
API & Business: api@quickpdfs.net

Company: D-Tech Studios
Product: QuickPDFs.net
Website: https://quickpdfs.net

We aim to respond to all formal legal queries within 5 business days.`,
      },
    ],
  },
];

// ─── Component ────────────────────────────────────────────────────────────────
export default function TermsOfService() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('acceptance');
  const [showBackToTop, setShowBackToTop] = useState(false);
  const sectionRefs = useRef({});

  // Show back-to-top
  useEffect(() => {
    const handler = () => setShowBackToTop(window.scrollY > 400);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  // Active section tracking
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) setActiveSection(entry.target.id);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    Object.values(sectionRefs.current).forEach(ref => { if (ref) observer.observe(ref); });
    return () => observer.disconnect();
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const LAST_UPDATED = 'March 18, 2026';
  const EFFECTIVE    = 'March 18, 2026';

  return (
    <div className="tos-page">

      {/* ── Hero ──────────────────────────────────────────── */}
      <section className="tos-hero">
        <div className="tos-hero-bg" aria-hidden="true" />
        <div className="tos-container">

          <div className="tos-hero-badge">
            <span className="tos-badge-dot" />
            D-Tech Studios · QuickPDFs.net
          </div>

          <h1 className="tos-hero-title">Terms of Service</h1>
          <p className="tos-hero-sub">
            These Terms govern your use of QuickPDFs.net and your relationship with D-Tech Studios.
            By using the Service you agree to these Terms please read them carefully.
          </p>

          <div className="tos-hero-meta">
            <span className="tos-meta-item">
              <Ic.Update /> Last updated: <strong>{LAST_UPDATED}</strong>
            </span>
            <span className="tos-meta-sep">·</span>
            <span className="tos-meta-item">
              Effective: <strong>{EFFECTIVE}</strong>
            </span>
          </div>

          {/* Key highlights */}
          <div className="tos-highlights">
            <p className="tos-highlights-label">Key points at a glance</p>
            <div className="tos-highlights-grid">
              {[
                { icon: Ic.Check,  color: '#10B981', text: 'Free plan stays free forever no tricks' },
                { icon: Ic.Check,  color: '#10B981', text: '7-day money-back guarantee on first payment' },
                { icon: Ic.Check,  color: '#10B981', text: 'Files auto-deleted within 1 hour, always' },
                { icon: Ic.Check,  color: '#10B981', text: 'You own your files we never claim ownership' },
                { icon: Ic.Check,  color: '#10B981', text: '14 days notice before any material Terms change' },
                { icon: Ic.Check,  color: '#10B981', text: 'Cancel your subscription at any time, no penalty' },
              ].map((h, i) => (
                <div key={i} className="tos-highlight-item">
                  <span className="tos-highlight-icon" style={{ color: h.color }}>
                    <h.icon />
                  </span>
                  {h.text}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── Body ──────────────────────────────────────────── */}
      <div className="tos-body">
        <div className="tos-container tos-body-inner">

          {/* TOC sidebar */}
          <aside className="tos-toc">
            <p className="tos-toc-label">Contents</p>
            <nav className="tos-toc-nav">
              {SECTIONS.map(s => (
                <button
                  key={s.id}
                  className={`tos-toc-item${activeSection === s.id ? ' active' : ''}`}
                  style={{ '--tc': s.color }}
                  onClick={() => scrollTo(s.id)}
                >
                  <span className="tos-toc-dot" style={{ background: s.color }} />
                  <span className="tos-toc-text">{s.title}</span>
                  <Ic.ChevronRight className="tos-toc-arrow" />
                </button>
              ))}
            </nav>
            <div className="tos-toc-footer">
              <button className="tos-toc-btn" onClick={() => navigate('/PrivacyPolicy')}>
                <Ic.Lock /> Privacy Policy
              </button>
              <button className="tos-toc-btn" onClick={() => navigate('/Disclaimer')}>
                <Ic.Scale /> Disclaimer
              </button>
              <button className="tos-toc-btn" onClick={() => navigate('/Contact')}>
                <Ic.Mail /> Contact us
              </button>
            </div>
          </aside>

          {/* Content */}
          <main className="tos-content">
            {SECTIONS.map(section => (
              <section
                key={section.id}
                id={section.id}
                ref={el => (sectionRefs.current[section.id] = el)}
                className="tos-section"
              >
                <div className="tos-section-head">
                  <span className="tos-section-icon" style={{ background: `${section.color}14`, color: section.color }}>
                    <section.icon />
                  </span>
                  <h2 className="tos-section-title">{section.title}</h2>
                </div>

                {section.content.map((block, i) => (
                  <div key={i} className="tos-block">
                    <h3 className="tos-block-title">{block.subtitle}</h3>
                    <div className="tos-block-body">
                      {block.body.split('\n\n').map((para, j) => (
                        <p
                          key={j}
                          className={
                            para.trim().startsWith('•') || para.includes('\n•')
                              ? 'tos-para tos-para--list'
                              : para === para.toUpperCase() && para.length > 20
                              ? 'tos-para tos-para--legal'
                              : 'tos-para'
                          }
                        >
                          {para.split('\n').map((line, k, arr) => (
                            <span key={k}>
                              {line}
                              {k < arr.length - 1 && <br />}
                            </span>
                          ))}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </section>
            ))}

            {/* Footer note */}
            <div className="tos-footer-note">
              <Ic.Info className="tos-footer-icon" />
              <div>
                <p className="tos-footer-title">These Terms work together with our other legal documents</p>
                <p className="tos-footer-body">
                  Read our{' '}
                  <button className="tos-inline-link" onClick={() => navigate('/PrivacyPolicy')}>Privacy Policy</button>
                  {' '}and{' '}
                  <button className="tos-inline-link" onClick={() => navigate('/Disclaimer')}>Disclaimer</button>
                  {' '}for the full picture of your rights and our responsibilities.
                  Questions? <button className="tos-inline-link" onClick={() => navigate('/Contact')}>Contact us</button>.
                </p>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Back to top */}
      {showBackToTop && (
        <button
          className="tos-back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Back to top"
        >
          <Ic.ArrowUp />
        </button>
      )}
    </div>
  );
}